<ng-container *ngIf="item">
  <ng-container
    *ngTemplateOutlet="
      itemHeaderTemplate;
      context: {
        $implicit: {
          item: item,
          index: index
        }
      }
    "></ng-container>
</ng-container>

<div *ngIf="item" class="list-item">
  <div
    #itemTemplate
    class="list-item-edit"
    [class.active]="item?.active"
    [class.create-mode]="item?.createMode"
    [class.selected]="collection?.selectedItems.has(item?.id)">
    <ng-container *rxFor="let field of fields; strategy: 'immediate'">
      <div
        *ngIf="!(field.hasOwnProperty('show') && !field.show)"
        [ngStyle]="field?.styles?.flex && { flex: field?.styles?.flex }"
        [style.width.px]="field?.styles?.width"
        [style.min-width.px]="field?.styles?.min">
        <div class="list-item__item" (click)="clickOnItem($event, field, item)">
          <ng-container *ngIf="!field?.html; else htmlTemplate">
            <ng-container *ngIf="item![field.key]; else noSet">
              <span class="text-ellipsis">
                {{ item![field.key] }}
              </span>
            </ng-container>
          </ng-container>

          <ng-template
            #htmlTemplate
            [ngTemplateOutlet]="field?.html || templates[field.key + 'Field']"
            [ngTemplateOutletContext]="{ item: item }">
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="item">
  <ng-container
    *ngTemplateOutlet="
      itemFooterTemplate;
      context: {
        $implicit: {
          item: item,
          index: index
        }
      }
    "></ng-container>
</ng-container>

<ng-template #noSet>
  <span class="no-set__value">
    {{ 'No set' | translate }}
  </span>
</ng-template>
